import { IBookAChat, IBookAMeeting } from '@app-types/websocket/expert.types';

import { createAction } from 'redux-act';
import { ISubscribe } from '@app-types/websocket/subscription.types';

export const subscribe = createAction<ISubscribe>('Subscribe');




// WEBPACK FOOTER //
// ./src/services/subscription/subscription.action.ts